import { ExtendableImage } from '@design-system/extendable-image';
import { Link } from '@design-system/link';
import classNames from 'classnames';
import React, { FC } from 'react';

import { LogoProps } from './models';

export const Logo: FC<LogoProps> = ({ className, image, link, onClick }) => {
  const LinkComponent = link?.component || Link;
  const linkProps = link?.props;

  return (
    <div className={classNames('cds-logo', className)}>
      {link && linkProps ? (
        <LinkComponent
          onClick={onClick}
          {...linkProps}
          className="cds-logo__link"
          variant="wrapper"
          rel="home"
        >
          <ExtendableImage {...image} />
        </LinkComponent>
      ) : (
        <ExtendableImage {...image} />
      )}
    </div>
  );
};
